import { Button } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { StationAdditionItemEdit } from "./station-addition.item.edit";
import {
  emptyStationAddition,
  IStationAdditionItemForm,
} from "./station-addition.models";

export const StationAdditionItemAdd: FC<IStationAdditionItemForm> = ({
  index,
  setValue,
  getValues,
  fieldName,
}) => {
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      {isAddNewOpened && (
        <StationAdditionItemEdit
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          value={emptyStationAddition}
          index={index}
          onCancel={() => {
            setAddNewOpenedState(false);
          }}
          isNew
        />
      )}
      {!isAddNewOpened && (
        <div className="add_item_button_wrapper">
          <Button type="button" onClick={() => setAddNewOpenedState(true)}>
            {t("general.APPEND")}
          </Button>
        </div>
      )}
    </>
  );
};
